/**
 * Brand mark.
 *
 * Deliberately NOT a monogram and not anything resembling HelloFresh's own branding: this is
 * an unaffiliated personal tool that reads HelloFresh recipe data, and its iconography must
 * not imply endorsement or affiliation (DESIGN_GUIDELINES.md §8.1).
 */

export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: 10,
        background: 'var(--ff-purple)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
      }}
    >
      <svg
        width={size * 0.6}
        height={size * 0.6}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* fork + leaf */}
        <path d="M6 3v6a3 3 0 0 0 6 0V3" />
        <path d="M9 12v9" />
        <path d="M18 3c-2.5 2-4 4.5-4 8 0 2 .8 3.2 2 3.8V21" />
      </svg>
    </span>
  );
}
